// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, Copy, Maximize2 } from 'lucide-react';

// export default function Cokedetail() {
//   const [selectedDevice, setSelectedDevice] = useState('Mobile');

//   return (
//     <div className="flex h-screen bg-gray-50 mt-14">
//       {/* Left Sidebar */}
//       <div className="w-64 bg-white border-r border-gray-200 p-4">
//         <div className="mb-6">
//           <h1 className="text-xl font-semibold text-gray-800 mb-1">Coke Upsize</h1>
//           <p className="text-sm text-blue-500 mb-2">ID: 235756</p>
//           <button className="text-sm text-blue-500 hover:underline">
//             Switch to previous version
//           </button>
//         </div>

//         <div className="bg-blue-500 text-white p-3 rounded-lg">
//           <h3 className="font-medium mb-2">Coke Upsize_Coke_upsize...</h3>
//           <div className="text-xs space-y-1">
//             <p>Ad dimension: 300x600</p>
//             <p>Ad type: Banner - Javascript tag</p>
//           </div>
//         </div>
//       </div>

//       {/* Center Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <div className="bg-white border-b border-gray-200 p-4">
//           <div className="flex items-center justify-between">
//             <h2 className="text-lg font-medium text-gray-800 flex items-center gap-2">
//               Coke Upsize_Coke_upsize_300x600_prod_300x600
//               <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600" />
//             </h2>
//             <div className="flex items-center gap-2">
//               <span 
//                 className={`px-2 py-1 rounded-full text-xs ${
//                   selectedDevice === 'Mobile' 
//                     ? 'bg-purple-100 text-purple-700' 
//                     : 'bg-gray-100 text-gray-600 cursor-pointer hover:bg-gray-200'
//                 }`}
//                 onClick={() => setSelectedDevice('Mobile')}
//               >
//                 Mobile
//               </span>
//               <span 
//                 className={`px-2 py-1 rounded-full text-xs ${
//                   selectedDevice === 'Desktop' 
//                     ? 'bg-purple-100 text-purple-700' 
//                     : 'bg-gray-100 text-gray-600 cursor-pointer hover:bg-gray-200'
//                 }`}
//                 onClick={() => setSelectedDevice('Desktop')}
//               >
//                 Desktop
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Navigation */}
//         <div className="bg-white border-b border-gray-200 p-4">
//           <div className="flex items-center justify-between">
//             <button className="flex items-center gap-2 text-gray-400 hover:text-gray-600">
//               <ChevronLeft className="h-4 w-4" />
//               Prev Ad
//             </button>
//             <button className="flex items-center gap-2 text-gray-400 hover:text-gray-600">
//               Next Ad
//               <ChevronRight className="h-4 w-4" />
//             </button>
//           </div>
//         </div>

//         {/* Ad Preview Area */}
//         <div className="flex-1 flex items-center justify-center p-8 bg-gray-100 relative">
//           {/* Navigation arrows */}
//           <button className="absolute left-8 top-1/2 transform -translate-y-1/2 flex items-center gap-2 text-gray-400 hover:text-gray-600 bg-white px-3 py-2 rounded-lg shadow-sm">
//             <ChevronLeft className="h-4 w-4" />
//             Prev Ad
//           </button>
//           <button className="absolute right-8 top-1/2 transform -translate-y-1/2 flex items-center gap-2 text-gray-400 hover:text-gray-600 bg-white px-3 py-2 rounded-lg shadow-sm">
//             Next Ad
//             <ChevronRight className="h-4 w-4" />
//           </button>

//           {/* Loading spinner */}
//           {/* <div className="absolute top-8 left-1/2 transform -translate-x-1/2">
//             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
//           </div> */}
          
//           {/* Mobile Device Frame */}
//           {selectedDevice === 'Mobile' ? (
//             <div className="relative">
//               {/* Selection background with dashed border */}
//               <div className="absolute -inset-4 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-3xl"></div>
              
//               {/* Mobile device frame */}
//               <div className="bg-gray-200 rounded-3xl p-4 shadow-xl">
//                 <div className="bg-white rounded-2xl p-2 shadow-inner">
//                   {/* Mobile screen with ad content */}
//                   <div className="w-80 h-96 bg-gray-100 rounded-xl overflow-hidden relative">
//                     {/* Your Coke ad image would go here */}
//                     <div className="w-full h-full bg-gray-300 flex items-center justify-center text-gray-500">
//                     <img src="/assets/coke.jpg" alt="Coke Ad" className="w-full h-full object-cover" />
//                     </div>
//                   </div>
//                 </div>
//                 {/* Home indicator */}
//                 <div className="w-32 h-1 bg-gray-400 rounded-full mx-auto mt-2"></div>
//               </div>
//             </div>
//           ) : (
//             <div className="relative">
//               {/* Selection background for desktop */}
//               <div className="absolute -inset-4 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-lg"></div>
              
//               {/* Desktop ad frame */}
//               <div className="bg-white rounded-lg shadow-xl p-4">
//                 <div className="w-80 h-96 bg-gray-100 rounded overflow-hidden relative">
//                   {/* Your Coke ad image would go here */}
//                   <div className="w-full h-full bg-gray-300 flex items-center justify-center text-gray-500">
//                   <img src="/assets/coke.jpg" alt="Coke Ad" className="w-full h-full object-cover" />

//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Right Sidebar */}
//       <div className="w-80 bg-white border-l border-gray-200 p-4">
//         <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>
        
//         <div className="space-y-6">
//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-2">Ad Info</h4>
//           </div>
          
//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Dimension:</h4>
//             <p className="text-gray-800">300x600</p>
//           </div>
          
//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Type:</h4>
//             <p className="text-gray-800">Banner - Javascript tag</p>
//           </div>
          
//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-1">Creative ID:</h4>
//             <p className="text-gray-800">1526050</p>
//           </div>
          
//           <button className="text-blue-500 hover:underline text-sm">
//             Open Full-Size Creative
//           </button>
          
//           {/* QR Code */}
//           <div className="mt-8">
//             <div className="w-32 h-32 bg-white border-2 border-gray-300 p-2">
//               <div className="w-full h-full bg-black relative">
//                 {/* QR Code pattern */}
//                 <div className="absolute inset-1 bg-white"></div>
//                 <div className="absolute top-1 left-1 w-6 h-6 bg-black"></div>
//                 <div className="absolute top-1 right-1 w-6 h-6 bg-black"></div>
//                 <div className="absolute bottom-1 left-1 w-6 h-6 bg-black"></div>
//                 <div className="absolute top-2 left-2 w-4 h-4 bg-white"></div>
//                 <div className="absolute top-2 right-2 w-4 h-4 bg-white"></div>
//                 <div className="absolute bottom-2 left-2 w-4 h-4 bg-white"></div>
//                 <div className="absolute top-3 left-3 w-2 h-2 bg-black"></div>
//                 <div className="absolute top-3 right-3 w-2 h-2 bg-black"></div>
//                 <div className="absolute bottom-3 left-3 w-2 h-2 bg-black"></div>
//                 {/* Center pattern */}
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-black"></div>
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-white"></div>
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-black"></div>
//                 {/* Random dots for QR pattern */}
//                 <div className="absolute top-8 left-4 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-10 left-6 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-12 left-8 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-14 left-10 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-16 left-4 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-18 left-8 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-20 left-6 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-22 left-10 w-1 h-1 bg-black"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Copy } from 'lucide-react';

export default function Cokedetail() {
  const [selectedDevice, setSelectedDevice] = useState('Mobile');

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-50 mt-14 overflow-x-hidden">
      {/* Left Sidebar */}
      <div className="w-full md:w-64 bg-white border-b md:border-b-0 md:border-r border-gray-200 p-4">
        <div className="mb-6">
          <h1 className="text-xl font-semibold text-gray-800 mb-1">Coke Upsize</h1>
          <p className="text-sm text-blue-500 mb-2">ID: 235756</p>
          <button className="text-sm text-blue-500 hover:underline">
            Switch to previous version
          </button>
        </div>

        <div className="bg-blue-500 text-white p-3 rounded-lg">
          <h3 className="font-medium mb-2 truncate">Coke Upsize_Coke_upsize...</h3>
          <div className="text-xs space-y-1">
            <p>Ad dimension: 300x600</p>
            <p>Ad type: Banner - Javascript tag</p>
          </div>
        </div>
      </div>

      {/* Center Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 p-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
            <h2 className="text-lg font-medium text-gray-800 flex items-center gap-2">
              Coke Upsize_Coke_upsize_300x600_prod_300x600
              <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600" />
            </h2>
            <div className="flex items-center gap-2">
              <span
                className={`px-2 py-1 rounded-full text-xs cursor-pointer ${
                  selectedDevice === 'Mobile'
                    ? 'bg-purple-100 text-purple-700'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
                onClick={() => setSelectedDevice('Mobile')}
              >
                Mobile
              </span>
              <span
                className={`px-2 py-1 rounded-full text-xs cursor-pointer ${
                  selectedDevice === 'Desktop'
                    ? 'bg-purple-100 text-purple-700'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
                onClick={() => setSelectedDevice('Desktop')}
              >
                Desktop
              </span>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="bg-white border-b border-gray-200 p-4 flex items-center justify-between">
          <button className="flex items-center gap-2 text-gray-400 hover:text-gray-600">
            <ChevronLeft className="h-4 w-4" />
            Prev Ad
          </button>
          <button className="flex items-center gap-2 text-gray-400 hover:text-gray-600">
            Next Ad
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>

        {/* Ad Preview Area */}
        <div className="flex-1 flex items-center justify-center p-4 md:p-8 bg-gray-100 relative overflow-auto">
          {/* Navigation arrows */}
          <button className="absolute left-2 md:left-8 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-400 hover:text-gray-600 bg-white px-2 py-1 rounded-lg shadow-sm text-sm">
            <ChevronLeft className="h-4 w-4" />
            Prev Ad
          </button>
          <button className="absolute right-2 md:right-8 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-400 hover:text-gray-600 bg-white px-2 py-1 rounded-lg shadow-sm text-sm">
            Next Ad
            <ChevronRight className="h-4 w-4" />
          </button>

          {/* Mobile Device Frame */}
          {selectedDevice === 'Mobile' ? (
            <div className="relative max-w-xs mx-auto">
              {/* Selection background with dashed border */}
              <div className="absolute -inset-2 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-3xl"></div>

              {/* Mobile device frame */}
              <div className="bg-gray-200 rounded-3xl p-3 shadow-xl">
                <div className="bg-white rounded-2xl p-2 shadow-inner">
                  {/* Mobile screen with ad content */}
                  <div className="w-[250px] h-[500px] bg-gray-100 rounded-xl overflow-hidden relative">
                    <img src="/assets/coke.jpg" alt="Coke Ad" className="w-full h-full object-contain" />
                  </div>
                </div>
                {/* Home indicator */}
                <div className="w-24 h-1 bg-gray-400 rounded-full mx-auto mt-2"></div>
              </div>
            </div>
          ) : (
            <div className="relative max-w-xs mx-auto">
              {/* Selection background for desktop */}
              <div className="absolute -inset-2 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-lg"></div>

              {/* Desktop ad frame */}
              <div className="bg-white rounded-lg shadow-xl p-4">
                <div className="w-[250px] h-[500px] bg-gray-100 rounded overflow-hidden relative">
                  <img src="/assets/coke.jpg" alt="Coke Ad" className="w-full h-full object-contain" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Right Sidebar */}
      <div className="w-full md:w-80 bg-white border-t md:border-t-0 md:border-l border-gray-200 p-4">
        <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>

        <div className="space-y-6">
          <div>
            <h4 className="text-sm font-medium text-gray-600 mb-2">Ad Info</h4>
          </div>

          <div>
            <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Dimension:</h4>
            <p className="text-gray-800">300x600</p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Type:</h4>
            <p className="text-gray-800">Banner - Javascript tag</p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-gray-600 mb-1">Creative ID:</h4>
            <p className="text-gray-800">1526050</p>
          </div>

          <button className="text-blue-500 hover:underline text-sm">
            Open Full-Size Creative
          </button>

          {/* QR Code */}
          <div className="mt-8 flex justify-center">
            <div className="w-32 h-32 bg-white border-2 border-gray-300 p-2">
              <div className="w-full h-full bg-black relative">
                {/* QR Code pattern */}
                <div className="absolute inset-1 bg-white"></div>
                <div className="absolute top-1 left-1 w-6 h-6 bg-black"></div>
                <div className="absolute top-1 right-1 w-6 h-6 bg-black"></div>
                <div className="absolute bottom-1 left-1 w-6 h-6 bg-black"></div>
                <div className="absolute top-2 left-2 w-4 h-4 bg-white"></div>
                <div className="absolute top-2 right-2 w-4 h-4 bg-white"></div>
                <div className="absolute bottom-2 left-2 w-4 h-4 bg-white"></div>
                <div className="absolute top-3 left-3 w-2 h-2 bg-black"></div>
                <div className="absolute top-3 right-3 w-2 h-2 bg-black"></div>
                <div className="absolute bottom-3 left-3 w-2 h-2 bg-black"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-black"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-white"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-black"></div>
                {/* Random dots */}
                <div className="absolute top-8 left-4 w-1 h-1 bg-black"></div>
                <div className="absolute top-10 left-6 w-1 h-1 bg-black"></div>
                <div className="absolute top-12 left-8 w-1 h-1 bg-black"></div>
                <div className="absolute top-14 left-10 w-1 h-1 bg-black"></div>
                <div className="absolute top-16 left-4 w-1 h-1 bg-black"></div>
                <div className="absolute top-18 left-8 w-1 h-1 bg-black"></div>
                <div className="absolute top-20 left-6 w-1 h-1 bg-black"></div>
                <div className="absolute top-22 left-10 w-1 h-1 bg-black"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
